import React from 'react'
import cx from 'classnames'
import { Icon } from '@manychat/manyui'

import brokenLogo from './icon_sidebar_logo_broken.svg'

import * as cm from './IconBrokenLogo.module.css'

interface IconBrokenLogoProps {
  className?: string
}

export const IconBrokenLogo = ({ className }: IconBrokenLogoProps) => (
  <span className={cx(cm.wrapper, className)} aria-hidden="true">
    <img className={cm.logo} src={brokenLogo} alt="" />
    <span className={cm.badge}>
      <Icon.Close />
    </span>
  </span>
)
